<template>
    <v-container fluid class="pl-0 pr-0" v-resize="onResize">
        <c-index
            title          = "Index"
            :items         = "items"
            :criterion     = "criterion"
            :filter        = "indexFilter"
            :enable-search = "false"
            :miminize      = "false"
            :height-diff   = "140"
            @selected      = "onSelect"
            ref            = "index"
            class          = "w-75"
        >
            <template v-slot:filter>
                <v-row class="no-frame lm-border pa-3 mb-2 mt-0 pt-0">
                    <v-col class="no-frame">
                        <v-text-field
                            v-model="criterion"
                            hide-details
                        />
                    </v-col>
                </v-row>
            </template>

            <template v-slot:pre-filter>
                <div style="margin-top: -2px">
                    <c-toolbar-button
                        v-if    = "createAllowed && settingsAdmin"
                        class   = "mr-2"
                        size    = "22"
                        icon    = "mdi-plus"
                        tooltip = "Neue Vorlage anlegen"
                        color   = "white"
                        @click  = "onCreate"
                    />
                </div>
            </template>

            <template v-slot:item="{ item }">
                <div class="template-name v-flex">
                    <div>
                        <div v-if="!item.deleted">{{ item.name }}</div>
                        <div v-if= "item.deleted"><s>{{ item.name }}</s></div>
                    </div>
                </div>
            </template>

            <template v-slot:detail="{  }">
                <v-row class="no-frame mt-3 ml-3" >
                    <v-col class="pa-0" style="min-width: 70%; max-width: 70%">
                        <div v-if="template" class="" style="height: calc(100% - 25px)">
                            <c-column-header
                                class  = "primary white--text"
                                :label = "title"
                            >
                                <template v-slot:filter>
                                    <div>
                                        <a @click="onStore" class="mr-2" v-if="settingsAdmin">
                                            <v-icon size="22" color="white">mdi-content-save</v-icon>
                                        </a>
                                    </div>
                                </template>
                                <template v-slot:pre>
                                    <div class="white--text" v-if="settingsAdmin">
                                        <v-switch
                                            v-model = "template.deleted"
                                            class   = "pt-0 mt-1"
                                            :ripple = "false"
                                            hide-details
                                            dense
                                            color="red"
                                            @change = "onRemove"
                                        />
                                    </div>
                                </template>
                            </c-column-header>

                            <div class="lm-border pa-3 mt-1">
                                <slot name="ident" v-bind:item="template" />
                            </div>

                            <div class="mt-3">
                                <v-row class="no-frame">
                                    <v-col class="no-frame" >
                                        <vue-editor
                                            v-if            = "settingsAdmin"
                                            v-model         = "template.content"
                                            :editor-toolbar = "customToolbar"
                                            ref             = "editor"
                                        />
                                        <div v-if="!settingsAdmin" class="lm-border pa-3" v-html="template.content">
                                        </div>
                                    </v-col>
                                </v-row>
                            </div>
                        </div>
                    </v-col>

                    <v-col class="pa-0 pl-3" style="min-width: 30%; max-width: 30%">
                        <div v-if="template" class="h-100">
                            <c-column-header
                                class="primary white--text"
                                label="Variablen"
                            />
                            <div class="lm-border pa-3 w-100 mt-1" style="height: calc(100% - 46px)">
                                <div class="v-flex w-100">
                                    <v-text-field
                                        v-model        = "variableFilter"
                                        autocomplete   = "off"
                                        autocorrect    = "off"
                                        autocapitalize = "off"
                                        spellcheck     = "false"
                                        append-icon    = "fas fa-search"
                                        class="pb-4 pl-0 pr-0 "
                                        clearable
                                        hide-details
                                    />
                                </div>
                                <div v-if="variables" style="overflow-y: scroll; width: calc(100% + 10px)" :style="variableStyle">
                                    <input type="hidden" id="clipboard" :value="clipboard">
                                    <div
                                        v-for="(variable, index) in filteredVariables"
                                        :key="index"
                                        class="v-flex lm-border template-variable secondary lighten-4"
                                    >
                                        <div class="text template-item">
                                            <a @click="onClipboard(variable)" >
                                                <div class="w-100">
                                                    <v-icon color="primary">mdi-content-copy</v-icon>
                                                    {{ variable.name }}
                                                </div>
                                            </a>
                                        </div>
                                        <v-spacer />
                                        <c-tag
                                            :label = "variable.contextType.name"
                                            :width = "70"
                                            :active="true"
                                            class="ml-2 mt-1 mr-1"
                                        />
                                    </div>
                                </div>
                                <c-v-spacer />
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </template>
        </c-index>
    </v-container>
</template>

<script>

import Core           from "@/modules/core/service/Core";
import CIndex         from "@/modules/core/components/utils/CIndex";
import CColumnHeader  from "@/modules/core/components/utils/CColumnHeader";
import CTag           from "@/modules/core/components/utils/CTag";
import CVSpacer       from "@/modules/core/components/utils/CVSpacer";
import {Quill} from "vue2-editor";
import CToolbarButton from "@/modules/core/components/utils/CToolbarButton.vue";

const Size = Quill.import('attributors/style/size');
Size.whitelist = ['10px', '12px', '14px', '16px'];
Quill.register(Size, true);

export default {
    name: "TemplateBase",

    components: {
        CToolbarButton,
        CVSpacer,
        CColumnHeader,
        CIndex,
        CTag
    },

    props: {
        title: {
            required: true,
            type    : String,
        },

        items: {
            required: false,
            type    : Array,
            default : function () {
                return [];
            }
        },

        variables: {
            required: false,
            type    : Array,
            default : function () {
                return [];
            }
        },

        headerHeight: {
            required: false,
            type    : Number,
            default : function () {
                return 425;
            }
        },
        createAllowed: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        },
        settingsAdmin: {

        }
    },

    data: () => ({
        criterion: "",
        variableFilter: "",
        variableStyle : null,
        signatures    : [],
        template      : null,
        clipboard     : null,
        customToolbar: [
            [{ header: [1, 2, 3, false] }],
            [   { size: Size.whitelist }
            ],
            ["bold", "italic", "underline"],
            [{ list: "ordered" }, { list: "bullet" }],
            ["image"],
        ]
    }),

    computed: {
        filteredVariables () {
            if (this.variableFilter && this.variableFilter.length > 0) {
                return this.variables.filter(v => v.name.includes (this.variableFilter));
            }

            return this.variables;
        },
    },

    methods: {
        refresh () {
            this.$refs.index.refresh();
        },

        indexFilter (item) {
            if (this.criterion && this.criterion.length > 0) {
                if (!item.name.includes (this.criterion)) {
                    return false;
                }
            }

            return true;
        },

        onCreate () {
            this.$emit("create");
        },

        onStore () {
            this.$emit("save", this.template);
        },

        onResize () {
            if (!this.$refs.editor) {
                return;
            }

            const element = this.$refs.editor.$el;
            const editor  = element.querySelector('.ql-editor');

            if (!editor) {
                return;
            }
           // const height = window.innerHeight - 550;


            const variableHeight = window.innerHeight - 275;
            editor.style.maxHeight =(window.innerHeight - 560) + 'px';
            this.variableStyle = "height: " + variableHeight + "px; max-height: " + variableHeight + "px";
        },

        onSelect (item) {
            this.template = item;
            this.$nextTick(() => {
                this.onResize();
            })
        },

        onRemove () {
            this.$emit("remove", this.template);
        },

        async onClipboard (variable) {
            await navigator.clipboard.writeText(" [" + variable.name + "] ");
            Core.message.hint(this, variable.name + " wurde in Clipboard kopiert!")
        }
    }
}
</script>

<style scoped>

.template-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 16px;
}

.template-variable {
    height: 28px;
    margin-bottom: 10px;
}

.template-variable .text {
    width: calc(75% - 10px);
    border-radius: 5px;
    padding-left: 10px;
    padding-top: 2px;
    font-size: 15px;
}

.template-variable .text a {
}

.template-variable .type {
    font-size: 15px;
    width: 25%;
    text-align: center;
    color: gray;
    border-radius: 5px;
    padding-top: 3px;
}

.template-item {
    cursor: pointer;
}

::v-deep .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="10px"]::before {
    content: 'Kleine Schrift';
    font-size: 10px !important;
}

::v-deep .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="12px"]::before {
    content: 'Normal';
    font-size: 12px !important;
}

::v-deep .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="14px"]::before {
    content: 'Mitttel';
    font-size: 14px !important;
}

::v-deep .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="16px"]::before {
    content: 'Gross';
    font-size: 16px !important;
}

::v-deep .ql-editor {
    font-size: 12px!important;
    color: black;
    zoom: 1.3;
    letter-spacing: 0.0em;
}

::v-deep p {
    margin-bottom: 0 !important;
}

</style>